// Outrights uses a green accent instead of the global blue --bs-primary.
// Centralised here so a single change propagates to every outrights surface.
export const OUTRIGHT_ACCENT = '#00cd00';
export const OUTRIGHT_ACCENT_RGB = '0, 205, 0';
export const OUTRIGHT_ACCENT_INK = '#0c1014';
